module.exports = __webpack_public_path__ + "static/media/status_new.3791182b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/manual/status_new.jpg
// module id = 1880
// module chunks = 0